export const news = [
  {
    id: "n1",
    title: "后入影视网独家专访：《星际裂痕》导演谈宇宙叙事与人性抉择",
    summary:
      "在票房与口碑双丰收之后，《星际裂痕》导演首次公开分享影片背后的创作逻辑，以及他如何看待科幻电影中的人性命题。",
    content: [
      "上映三周，《星际裂痕》以稳健的姿态刷新了同类型影片的多项纪录。比数字更值得关注的，是影片在宏大宇宙背景下对人性抉择的细腻刻画。",
      "在接受本站专访时，导演表示，这道\u201c裂痕\u201d从来不只是物理意义上的天体现象，而更像是一面镜子，映照出人类面对未知时的恐惧与勇气。\u201c我们想拍的不是飞船，而是坐在飞船里的人。\u201d",
      "谈及备受讨论的结局，导演坦言剧本曾有过三个版本。最终呈现的这一版，强调了选择本身的分量——不是关于对错，而是关于承担。",
      "影片的视觉团队也首次披露了裂痕特效的制作过程：从最早的实体模型，到后期超过两千层的合成，团队花费了整整十一个月。",
      "据悉，续作的剧本已经进入筹备阶段，但主创团队强调，不会为了赶档期而牺牲叙事质量。",
    ],
    date: "2026-10-14",
    category: "独家专访",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20director%20interview%20scene%20with%20studio%20lights%20and%20camera%20equipment%2C%20navy%20blue%20and%20warm%20orange%20tones%2C%20editorial%20photography%2C%20painterly%2C%20no%20text&width=800&height=450&seq=news-1&orientation=landscape",
  },
  {
    id: "n2",
    title: "2026 秋季剧集前瞻：十部值得期待的新剧",
    summary:
      "从古装权谋到科幻悬疑，本季上新的剧集类型前所未有的丰富。我们为你梳理出最值得关注的十部作品。",
    content: [
      "随着秋季档正式开启，各大平台陆续公布了本季的剧集排播计划。从目前的片单来看，今年秋季档的类型分布比往年更为均衡。",
      "古装题材依然是重头戏，《权谋天下》第二季的回归最受关注；而悬疑赛道则出现了更多高概念的尝试，比如以记忆错位为核心设定的《迷雾档案》。",
      "值得一提的是，本季有多部作品尝试了更短的集数与更快的叙事节奏，试图贴近当下观众的观看习惯。",
      "在演员阵容方面，实力派与新生代的搭配成为主流，多部作品都选择了\u201c老带新\u201d的组合方式。",
      "我们将持续跟进本季剧集的口碑变化，并在后续报道中带来更详细的评测。",
    ],
    date: "2026-10-12",
    category: "剧集前瞻",
    cover:
      "https://readdy.ai/api/search-image?query=autumn%20season%20tv%20series%20promo%20scene%20with%20theater%20seats%20and%20warm%20spotlight%2C%20navy%20blue%20and%20orange%20tones%2C%20cinematic%20editorial%20painterly%2C%20no%20text&width=800&height=450&seq=news-2&orientation=landscape",
  },
  {
    id: "n3",
    title: "《长安幻夜》票房破十亿，古装悬疑题材再掀热潮",
    summary:
      "上映第十二天，《长安幻夜》正式迈过十亿票房门槛，成为本季度最亮眼的黑马之一。",
    content: [
      "古装悬疑片《长安幻夜》自上映以来便保持着稳定的票房走势，截至发稿，累计票房已正式突破十亿元。",
      "业内人士分析，影片成功的关键在于将东方美学与类型叙事做了较好的平衡，既有视觉上的盛唐气象，也有足够扎实的推理线索。",
      "影片中关于\u201c幻术\u201d的设定成为观众讨论的焦点，围绕结局的多种解读在社交平台上持续发酵。",
      "制片方透露，影片的海外发行计划已经在推进中，多个国家和地区的上映时间将在近期公布。",
      "与此同时，同类型的古装悬疑项目立项数量明显增多，市场对这一题材的关注度持续升温。",
    ],
    date: "2026-10-10",
    category: "票房动态",
    cover:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20city%20at%20night%20with%20red%20lanterns%20and%20glowing%20palace%2C%20cinematic%20editorial%20scene%2C%20navy%20blue%20and%20warm%20orange%2C%20painterly%2C%20no%20text&width=800&height=450&seq=news-3&orientation=landscape",
  },
  {
    id: "n4",
    title: "流媒体平台竞争加剧，原创内容成关键战场",
    summary:
      "当用户增长逐渐见顶，各大流媒体平台不约而同地把重心转向了原创内容的投入与储备。",
    content: [
      "过去一年，全球主要流媒体平台的用户增长普遍放缓，行业的竞争重心正从\u201c拉新\u201d转向\u201c留存\u201d。",
      "在这一背景下，原创内容成为了各平台最核心的差异化武器。多部高投入的原创剧集和电影被排上日程。",
      "有分析师指出，单纯追求数量的时代已经过去，如何在有限预算内打磨出真正有辨识度的作品，才是平台需要回答的问题。",
      "与此同时，平台与独立制作团队的合作模式也在发生变化，更多中小成本项目获得了与头部项目同等的曝光机会。",
      "可以预见，未来一年内容市场的竞争将更加激烈，而这对于观众而言，未必不是一件好事。",
    ],
    date: "2026-10-08",
    category: "行业观察",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20streaming%20media%20control%20room%20with%20glowing%20screens%20and%20data%2C%20navy%20blue%20and%20orange%20accent%20lighting%2C%20editorial%20painterly%2C%20no%20text&width=800&height=450&seq=news-4&orientation=landscape",
  },
  {
    id: "n5",
    title: "演技派齐聚《都市迷城》第二季，主创团队揭秘幕后",
    summary:
      "备受期待的《都市迷城》第二季正式开机，原班人马悉数回归，同时加入多位实力派演员。",
    content: [
      "在首季收获口碑之后，《都市迷城》第二季于近日正式开机。主创团队在开机仪式上分享了新一季的创作方向。",
      "据制片人介绍，第二季将延续首季的悬疑基调，但会把叙事视角从单一的警探视角拓展到更复杂的人物群像。",
      "几位新加入的演员表示，正是因为被首季的剧本打动，才决定参与这个项目。",
      "主创团队还透露，第二季的拍摄周期预计将持续四个月，大量戏份会在夜间实景拍摄，以还原都市的氛围质感。",
      "该剧预计将在明年与观众见面，具体播出时间尚未公布。",
    ],
    date: "2026-10-06",
    category: "剧组动态",
    cover:
      "https://readdy.ai/api/search-image?query=film%20crew%20on%20a%20night%20city%20film%20set%20with%20camera%20rig%20and%20lights%2C%20navy%20blue%20and%20orange%20tones%2C%20editorial%20painterly%2C%20no%20text&width=800&height=450&seq=news-5&orientation=landscape",
  },
  {
    id: "n6",
    title: "从《深海回声》看悬疑片的视听语言革新",
    summary:
      "《深海回声》用声音作为叙事的核心线索，为华语悬疑片提供了一种全新的表达可能。",
    content: [
      "在众多悬疑片中，《深海回声》显得格外特别——它几乎把\u201c声音\u201d当成了主角之一。",
      "影片大量使用了低频声波与失真音效，让观众在生理层面感受到深海带来的压迫感。这种处理在华语悬疑片中并不多见。",
      "导演在采访中提到，团队专门搭建了一套水下声学模拟系统，录制了数百小时的真实海底声音素材。",
      "乐评人认为，影片的配乐克制而精准，懂得在关键处\u201c留白\u201d，为悬念的铺陈留出了空间。",
      "这种以听觉为核心的叙事尝试，或许会影响未来一批同类型作品的创作思路。",
    ],
    date: "2026-10-04",
    category: "深度影评",
    cover:
      "https://readdy.ai/api/search-image?query=underwater%20deep%20sea%20scene%20with%20light%20rays%20and%20bubbles%20in%20dark%20blue%20water%2C%20cinematic%20editorial%20painterly%2C%20no%20text&width=800&height=450&seq=news-6&orientation=landscape",
  },
  {
    id: "n7",
    title: "暑期档观察：动画与合家欢电影成最大赢家",
    summary:
      "回顾刚过去的暑期档，动画与合家欢题材表现抢眼，成为档期内最稳定的票房支撑。",
    content: [
      "尽管暑期档整体大盘与往年基本持平，但细分题材的表现却呈现出明显的分化。",
      "动画与合家欢电影成为最大赢家，多部作品凭借稳定的口碑实现了票房的逆势增长。",
      "有影院经理表示，家长带着孩子观影的需求具有很强的确定性，这使得合家欢题材在档期内尤为可靠。",
      "相比之下，部分主打视效的大片由于题材趋同，反倒在竞争中失去优势。",
      "业内普遍认为，未来的档期布局将更加注重题材的差异化与观众群体的精准定位。",
    ],
    date: "2026-10-01",
    category: "市场分析",
    cover:
      "https://readdy.ai/api/search-image?query=colorful%20animation%20movie%20theater%20with%20popcorn%20and%20a%20bright%20screen%2C%20warm%20orange%20and%20navy%20tones%2C%20editorial%20painterly%2C%20no%20text&width=800&height=450&seq=news-7&orientation=landscape",
  },
  {
    id: "n8",
    title: "影视工业化提速，虚拟拍摄技术走进国产剧组",
    summary:
      "LED 虚拟拍摄棚正在被越来越多的国产剧组采用，它正在改变传统影视制作的工作方式。",
    content: [
      "走进新一代的虚拟拍摄棚，四周是巨大的 LED 屏幕，屏幕上实时渲染着远方的山林与云海。",
      "这项被称为\u201c虚拟制片\u201d的技术，允许剧组在棚内完成原本需要远赴外景拍摄的镜头，大幅缩短了制作周期。",
      "多位技术人员表示，虚拟拍摄最大的价值不仅在于节省成本，更在于让导演能够在现场即时看到接近成片的画面效果。",
      "当然，这项技术也带来了新的挑战，比如对前期美术与灯光设计提出了更高的要求。",
      "可以预见，随着成本进一步下降，虚拟拍摄将在更多题材的剧集中得到应用。",
    ],
    date: "2026-09-28",
    category: "技术前沿",
    cover:
      "https://readdy.ai/api/search-image?query=led%20virtual%20production%20studio%20with%20curved%20screen%20and%20film%20crew%2C%20navy%20blue%20and%20orange%20accent%20lighting%2C%20editorial%20painterly%2C%20no%20text&width=800&height=450&seq=news-8&orientation=landscape",
  },
  {
    id: "n9",
    title: "海外剧集引进回暖，多部高分美剧同步上线",
    summary:
      "沉寂一段时间之后，海外剧集的引进明显回暖，多部口碑新作实现了与海外同步上线。",
    content: [
      "近几个月来，海外剧集的引进数量明显增加，其中不乏口碑与热度双高的作品。",
      "与以往相比，本轮的引进节奏更快，多部剧集实现了与海外几乎同步的更新，观众追剧体验大幅提升。",
      "平台方表示，之所以加快节奏，是为了应对观众对\u201c及时性\u201d的强烈需求，减少剧透对观看体验的影响。",
      "在题材方面，悬疑、科幻与职场剧最受欢迎，而一些以往较少引进的类型也开始进入观众的视野。",
      "业内人士认为，引进市场的回暖将进一步丰富国内观众的观看选择。",
    ],
    date: "2026-09-25",
    category: "海外资讯",
    cover:
      "https://readdy.ai/api/search-image?query=global%20streaming%20world%20map%20with%20glowing%20connection%20lines%20and%20cinema%20elements%2C%20navy%20blue%20and%20orange%20tones%2C%20editorial%20painterly%2C%20no%20text&width=800&height=450&seq=news-9&orientation=landscape",
  },
];